import { createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction';
import { User } from '../../model/User';
import { AuthState, initialAuthState } from './auth.interface';
import { RequestType } from '../../model/enums/RequestType';

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    setRequestType: (state: AuthState, action: PayloadAction<RequestType>) => {
      state.requestType = action.payload;
    },
    setUser: (state: AuthState, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    resetState: (state: AuthState) => {
      state.user = initialAuthState.user;
      state.requestType = initialAuthState.requestType;
    }
  }
});

export const authReducer = authSlice.reducer;
export const authActions = authSlice.actions;

